import React from 'react';
import { Reveal } from './Reveal';
import { BookButton } from './BookButton';
import { familyCards } from '../data/homepage';
export function FamilySection() {
  return <section aria-labelledby="family-heading" className="on-light bg-paper pb-24 pt-12 md:pb-32" data-id="element-17" data-mp="1pw4mq0fsyfmv">
      <div className="mx-auto max-w-7xl px-6 md:px-10" data-id="element-18" data-mp="1b3jdvp6288ky">
        <Reveal className="max-w-3xl" data-id="element-19" data-mp="1g35so31jdwvv">
          <p className="text-sm font-semibold tracking-[0.2em] text-[#7A5F0E]" data-id="element-20" data-mp="1g249fbada432">WHY THIS MATTERS</p>
          <h2 id="family-heading" className="mt-4 font-serif text-4xl font-semibold leading-tight text-navy md:text-5xl" data-id="element-21" data-mp="127216hi1s2n3">
            You served. So did they.
          </h2>
          <div aria-hidden="true" className="mt-8 h-px w-16 bg-gold" data-id="element-22" data-mp="s8ckut5suq8y" />
          <p className="mt-8 text-lg leading-relaxed text-charcoal md:text-xl" data-id="element-23" data-mp="x6nscx8mgoo0">
            Every deployment had someone waiting at home. A husband or wife holding it together. Kids counting days on
            a calendar. Parents watching the news. Your rating is not just a number on a letter. It is what you bring
            home to the people who waited for you.
          </p>
        </Reveal>

        {/* Swipeable row on mobile, three-column grid from md up */}
        <ul aria-label="People who waited at home" tabIndex={0} className="no-scrollbar -mx-6 mt-14 flex snap-x snap-mandatory gap-5 overflow-x-auto px-6 pb-2 md:mx-0 md:grid md:grid-cols-3 md:gap-8 md:overflow-visible md:px-0 md:pb-0" data-id="element-24" data-mp="3d46c13ec3pwr">
          {familyCards.map(card => <li key={card.line} className="w-[80%] shrink-0 snap-start sm:w-[55%] md:w-auto" data-id="element-25" data-mp="2fhh5qhclmr53">
              <figure className="group" data-id="element-26" data-mp="2tgp6heoeu7be">
                <div className="aspect-[3/4] w-full overflow-hidden rounded-sm bg-navy-soft" data-id="element-27" data-mp="2thrvti6341p7">
                  <img src={card.src} alt={card.alt} width={1200} height={1600} loading="lazy" className="h-full w-full object-cover transition-[filter] duration-200 ease-out group-hover:brightness-110" data-id="element-28" data-mp="2pdagpwao6ckr" />
                </div>
                <figcaption className="mt-5 font-serif text-xl font-medium leading-snug text-navy md:text-2xl" data-id="element-29" data-mp="32hekporr38zs">
                  <span className="underline decoration-transparent decoration-1 underline-offset-[6px] transition-[text-decoration-color] duration-200 ease-out group-hover:decoration-gold" data-id="element-30" data-mp="37ibzrshgrmx2">
                    {card.line}
                  </span>
                </figcaption>
              </figure>
            </li>)}
        </ul>

        <Reveal className="mt-16 flex flex-col items-center gap-8 text-center" data-id="element-31" data-mp="2jplprot4fdpf">
          <p className="font-serif text-2xl italic leading-snug text-navy md:text-3xl" data-id="element-32" data-mp="2ns0bqhs36tkx">
            You came home. Let's make sure you're taken care of.
          </p>
          <BookButton data-id="element-33" data-mp="1w2x3ys0zr13j" />
        </Reveal>
      </div>
    </section>;
}